import React from "react";
import { connect } from 'react-redux'

import store from '../../redux/store';
import { getMessagesAsync, getMoreMessagesAsync, createMessageAsync, createNewMessage } from '../../redux/actions/messages.actions';
import { flashCharacterColorAsync } from '../../redux/actions/characters.actions';
import { newOrganisation, showOrganisation, disableKeyboardMovement, enableKeyboardMovement, showHelp, startLooking, hideAllMenus, startAreaSelect } from '../../redux/actions/keyboard-shortcuts.actions';
import {
    selectCharacter,
    selectCharacters,
    selectZones,
    selectOpenZone,
    selectCharacterZoneOrganisations,
    selectCharacterZoneAdminOrganisations,
    selectAreaSelect,
    selectPanel,
    selectMaterialTypes,
    selectTileTypes,
    selectMineralTypes,
    selectToolTypes,
    selectMetalTypes,
    selectKeyTypes,
    selectFurnitureTypes,
    selectWritingSurfaceTypes,
    selectWritingImplementTypes,
    selectWorkshopTypes,
    selectWeaponTypes,
    selectArmourTypes,
    selectClothingTypes,
    selectJewelleryTypes,
    selectFoodTypes,
} from '../../redux/selectors';
import { format, formatDistance, formatRelative, subDays } from 'date-fns';
import { createZoneAsync, deleteZoneAsync, updateZone } from '../../redux/actions/zone.actions'

import Menu from '../utils/menu/Menu';
import TextInput from '../utils/text-input/TextInput';

import { colyClient } from '../../services/Panel-initialisation.service';
import { client } from '../../services/client';

import { WORLD_WIDTH, WORLD_HEIGHT } from '../../services/biome-geography'

// import './Diary.css';

export const RESOURCE_OPTIONS = [
    {
        text: 'Armour',
        serviceName: 'armour-instances',
    },
    {
        text: 'Clothing',
        serviceName: 'clothing-instances',
    },
    {
        text: 'Food',
        serviceName: 'food-instances',
    },
    // {
    //     text: 'Furniture',
    //     serviceName: 'furniture-instances',
    // },
    // {
    //     text: 'Jewellery',
    //     serviceName: 'jewellery-instances',
    // },
    {
        text: 'Materials',
        serviceName: 'material-instances',
    },
    {
        text: 'Metals',
        serviceName: 'metal-instances',
    },
    {
        text: 'Minerals',
        serviceName: 'mineral-instances',
    },
    {
        text: 'Tools',
        serviceName: 'tool-instances',
    },
    {
        text: 'Weapons',
        serviceName: 'weapon-instances',
    },
    {
        text: 'Writing Surfaces',
        serviceName: 'writing-surface-instances',
    },
    {
        text: 'Tiles',
        serviceName: 'tile-instances',
    },
]

class Zone extends React.Component {
    state = {
        navigationHandler: this.navigationHandler.bind(this),
        isSetTextShowing: false,
        allowedResources: [ ...RESOURCE_OPTIONS ],
        allowedResourceTypes: [],
        type: 'Stockpile',
        delete: '',
        isServiceMenuDisabled: false,
        isTypeMenuDisabled: true,
        isSearchShowing: false,
        z: undefined
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.state.navigationHandler)
    }

    componentDidMount() {
        document.addEventListener('keydown', this.state.navigationHandler);

        this.saveChanges();
    }

    navigationHandler(event) {
        if ((event.key === 's' || event.key === 'S') && !this.state.isQuantityInputShowing) {
            this.setState({
                isSearchShowing: true
            });
            return;
        }

        if (this.state.isResourceSelectShowing && event.key === 'ArrowRight') {
            this.setState({
                isServiceMenuDisabled: true,
                isTypeMenuDisabled: false
            })
            
            return;
        }


        if (this.state.isResourceSelectShowing && event.key === 'ArrowLeft') {
            this.setState({
                isServiceMenuDisabled: false,
                isTypeMenuDisabled: true
            })
            
            return;
        }

        if (this.state.isSetTextShowing || this.state.isResourceSelectShowing) {
            return;
        }

        if (this.isEnabled('deleteZone') && event.key === 'x') {
            this.setState({
                isSetTextShowing: 'delete'
            })
            return;
        }
    }

    onSearchExit(event) {
        this.setState({
            isSearchShowing: false,
        })
        event.preventDefault();
        return;
    }

    onSearchSubmit(text) {
        this.setState({
            isSearchShowing: false,
            searchString: text,
        })
    }

    onSearchUpdate(text) {
        this.setState({
            searchString: text,
        })
    }

    editName() {
        // show input
        this.setState({
            isSetTextShowing: 'name'
        })
    }

    editDescription() {
        // show input
        this.setState({
            isSetTextShowing: 'description'
        })
    }

    editOrganisation() {
        if (this.state.organisation) {
            return;
        }

        this.setState({
            isOrganisationSelectShowing: true
        })
    }

    editResources() {
        this.setState({
            isResourceSelectShowing: true
        })
    }

    editType() {
        this.setState({
            isTypeSelectShowing: true
        })
    }

    viewEditZoneArea() {
        // ONLY CHARACTERS WITH ADMIN RIGHTS CAN ACTUALLY ALTER IT
        // this.props.hideAllMenus()
        this.props.startAreaSelect({
            position: this.props.character.position,
            areaSelectType: 'stockpile',
            isStartOfAreaSelect: true,
            isDisabled: this.state.organisation && !this.state.organisation?.adminIds.find(adminId => (adminId === this.props.character._id)),
            zoneSettings: {
                _id: this.props.zone._id,
                type: this.state.type,
                description: this.state.description,
                name: this.state.name,
                allowedResources: this.state.allowedResources,
                allowedResourceTypes: this.state.allowedResourceTypes,
                organisation: this.state.organisation, // if hauling on behalf of an org, use this
            }
        })
    }

    saveChanges() {
        if (!this.props.zone) {
            // And then when we save on that panel, we do this thing mate.
            colyClient.room.send('doAction', {
                serviceName: 'zones',
                name: 'create',
                data: {
                    type: this.state.type,
                    description: this.state.description,
                    name: this.state.name,
                    resources: this.state.allowedResources?.filter(Boolean).map(resource => (resource.serviceName)),
                    resourceTypes: this.state.allowedResourceTypes,
                    organisationId: this.state.organisation?._id, // if hauling on behalf of an org, use this
                    characterId: !this.state.organisation ? this.props.character._id : undefined,
                    panelId: this.props.zone?.panelId || this.props.panel.id,
                    panelAreas: this.state.panelAreas,
                    z: this.props.character.z
                },
            })
            return
        }

        colyClient.room.send('doAction', {
            serviceName: 'zones',
            name: 'patch',
            data: {
                _id: this.props.zone._id,
                description: this.state.description,
                name: this.state.name,
                resources: this.state.allowedResources?.filter(Boolean).map(resource => (resource.serviceName)),
                resourceTypes: this.state.allowedResourceTypes,
                panelAreas: this.state.panelAreas,
                panelId: this.state.panel?.id || this.props.zone?.panelId || this.props.panel.id,
                z: this.state.z !== undefined ? this.state.z : this.props.zone?.z,
                organisationId: this.state.organisation?._id,
                characterId: !this.state.organisation ? this.props.character._id : '',
                type: this.state.type,
            },
        })
    }

    isEnabled(action) {
        if (action === 'editType') {
            return !this.props.zone?._id
        }

        if (action === 'deleteZone') {
            if (this.state.zone?.organisationId) {
                return this.props.adminOrganisations.find(org => org._id === this.state.zone.organisationId)
            }

            return true;
        }
        return true
    }

    isFormValid() {
        return true
    }

    deleteZone() {
        this.props.deleteZoneAsync({ _id: this.props.zone?._id })
        this.props.hideAllMenus()
        event.preventDefault();
    }

    onEditSubmit(text) {
        if (this.state.isSetTextShowing === 'delete' && text === 'delete') {
            this.deleteZone();
        }

        this.setState({
            [this.state.isSetTextShowing]: text,
            isSetTextShowing: false
        })
        this.saveChanges()
    }

    onEditExit(text) {
        this.setState({
            isSetTextShowing: false
        })
    }

    onResourcesKeyPressed(option, event, selectedOption) {
        if (event.key === 'Escape' && !this.state.isSearchShowing) {
            this.setState({
                isResourceSelectShowing: false,
            })

            this.saveChanges()

            event.preventDefault();
        }
    }

    onTypeKeyPressed(option, event, selectedOption) {
        if (event.key === 'Escape') {
            this.setState({
                isTypeSelectShowing: false,
            })

            this.saveChanges()

            event.preventDefault();
        }
    }

    onResourceChosen(option) {
        const isExistingOption = this.state.allowedResources.find(resource => (resource.serviceName === option.serviceName))

        if (isExistingOption) {
            this.setState({
                allowedResources: [ ...this.state.allowedResources.filter(resource => (resource.serviceName !== option.serviceName)) ]
            })
            return
        }

        this.setState({
            allowedResources: [ ...this.state.allowedResources, option ]
        })
    }

    onResourceTypeChosen(option) {
        if (!this.state.highlightedServiceName) {
            return;
        }

        const isExistingOptionService = this.state.allowedResources.find(resource => (resource.serviceName === this.state.highlightedServiceName))

        const isExistingOption = this.state.allowedResourceTypes.find(resourceId => (resourceId === option._id))

        if (isExistingOption) {
            this.setState({
                allowedResourceTypes: [ ...this.state.allowedResourceTypes.filter(resourceId => (resourceId !== option._id)) ]
            })
            return
        }

        this.setState({
            allowedResourceTypes: [ ...this.state.allowedResourceTypes, option._id ]
        })
    }

    onTypeChosen(option) {        
        this.setState({
            type: option.text
        })

        this.saveChanges()
    }

    onOrganisationKeyPressed(option, event, selectedOption) {
        if (event.key === 'Escape' && !this.state.isSearchShowing) {
            this.setState({
                isOrganisationSelectShowing: false,
            })

            this.saveChanges()

            event.preventDefault();
        }
    }

    onOrganisationChosen(option) {
        if (!option._id) {
            return
        }

        this.setState({
            organisation: option
        })
    }

    static getDerivedStateFromProps(props, state) {
        if (!props.zone) {
            return;
        }

        if (props.zone !== state.zone) {
            state.zone = props.zone

            state.organisation = props.organisations.find(organisation => (organisation._id === props.zone.organisationId))

            state.name = props.zone.name
            state.description = props.zone.description
            state.type = props.zone.type
            state.allowedResources = props.zone.resources?.map(allowedResource => (RESOURCE_OPTIONS.find(option => (option.serviceName === allowedResource)))) || [ ...RESOURCE_OPTIONS ]
            state.allowedResourceTypes = props.zone.resourceTypes || []
            state.panel = props.zone.panel
            state.panelAreas = props.zone.panelAreas
            state.type = props.zone.type || 'Stockpile'
        }

        if (props.areaSelect && props.areaSelect?.startingCoords) {
            state.panelAreas = [
                {
                    x: Math.min(props.areaSelect?.startingCoords.x, props.areaSelect?.x),
                    y: Math.min(props.areaSelect?.startingCoords.y, props.areaSelect?.y),
                    width: Math.abs(props.areaSelect?.startingCoords.x - props.areaSelect?.x) + 1,
                    height: Math.abs(props.areaSelect?.startingCoords.y - props.areaSelect?.y) + 1
                }
            ]

            state.panel = props.panel
            state.z = props.character.z
        }
        return state;
    }

    getPanelCoordsFromId(panelId) {
        return {
            x: (panelId % WORLD_WIDTH) - 1,
            y: Math.floor(panelId / WORLD_WIDTH)
        }
    }

    getPanelDirection(panelId) {
        const zonePanelCoords = this.getPanelCoordsFromId(panelId);
        const currentPanelCoords = { x: this.props.panel.x, y: this.props.panel.y }

        const amountNorth = currentPanelCoords.y - zonePanelCoords.y
        const amountEast = currentPanelCoords.x - zonePanelCoords.x

        let panelDirectionString = '['

        if (amountNorth < 0) {
            const amountSouth = amountNorth * -1
            panelDirectionString = `[${amountSouth}S,`
        } else if (amountNorth >= 0) {
            panelDirectionString = `[${amountNorth}N,`
        }

        if (amountEast < 0) {
            const amountWest = amountEast * -1
            panelDirectionString += `${amountWest}E]`
        } else if (amountEast >= 0) {
            panelDirectionString += `${amountEast}W]`
        }

        if (amountEast === 0 && amountNorth === 0) {
            panelDirectionString = 'Current panel'

            const amountDown = this.props.character.z - this.props.zone.z;

            if (amountDown > 0) {
                panelDirectionString = `${amountDown} Levels down`
            } else if (amountDown < 0) {
                panelDirectionString = `${amountDown * -1} Levels up`
            }
        }

        return panelDirectionString
    }

    chooseOption(option, event) {
        if (this.state.isSetTextShowing) {
            return;
        }

        if (option.text === 'Zone Name: ') {
            this.editName()
        }

        if (option.text === 'Description: ') {
            this.editDescription()
        }

        if (option.text === 'Organisation: ') {
            this.editOrganisation()
        }

        if (option.text === 'Type: ') {
            this.editType()
        }

        if (option.text === 'Allowed resources: ') {
            this.editResources()
        }

        if (option.text === 'Location: ') {
            this.viewEditZoneArea()
            event.preventDefault();
            event.stopPropagation();
        }
    }

    onResourceServiceHighlighted(option) {
        this.setState({
            highlightedServiceName: option.serviceName
        })
    }

    getResourceTypeOptions() {
        if (!this.state.highlightedServiceName) {
            return [];
        }

        let typeName = this.state.highlightedServiceName.split('-')[0] + 'Types';

        if (typeName === 'writingTypes') {
            typeName = 'writingSurfaceTypes'
        }

        return this.props[typeName].map((option) => {
            if (this.state.allowedResourceTypes.find(resourceId => resourceId === option._id)) {
                return {
                    ...option,
                    text: option.name,
                    hint: ' Selected'
                }
            }

            const isParentSelected = this.state.allowedResources.find(allowed => allowed.serviceName === this.state.highlightedServiceName)

            return {
                ...option,
                text: option.name,
                hint: isParentSelected ? ' Auto-Selected' : ''
            }
        })
        .filter((recipe) => {
            if (this.state.searchString) {
                if (!recipe.text) {
                    return -1
                }
                return recipe.text.toLowerCase().indexOf(this.state.searchString.toLowerCase()) > -1
            }

            return true;
        })
    }

    getAllowedResourcesHint() {
        if (this.state.allowedResources?.length === RESOURCE_OPTIONS.length) {
            return 'All'
        }

        const selectedResources = this.state.allowedResources.filter(Boolean)?.map(resource => (resource.text))

        const selectedResourceTypes = this.state.allowedResourceTypes.map(resourceId => {
            let result;
            RESOURCE_OPTIONS.find((option) => {
                const serviceKey = option.serviceName.split('-')[0] + 'Types'
                const resourceType = this.props[serviceKey].find(resourceType => (resourceType._id === resourceId))
                result = resourceType?.name
                return resourceType?.name
            })

            return result;
        })

        if (selectedResources.concat(selectedResourceTypes).join(', ').length > 250) {
            return (selectedResources.concat(selectedResourceTypes).join(', ')).slice(0, 250) + '...'
        }

        return selectedResources.concat(selectedResourceTypes).join(', ')
    }

    render() {
        let locationHint = `Panel: ${this.getPanelDirection(this.props.zone?.panelId)}`

        if (this.state.panelAreas && this.state.panelAreas[0]) {
            const panelArea = this.state.panelAreas[0]
            locationHint += `, Position: [${panelArea.x},${panelArea.y}], Size: ${panelArea.width}x${panelArea.height}`
        }

        return (
            <div className="conversation-tree-wizard">
                <div className="conversation-tree-wizard-container">
                    {
                        this.state.isSetTextShowing ? (
                            <div className="conversation-wizard-edit-text-container">
                                <p className="conversation-wizard-exit"><span className="action">ESC</span> to exit</p>
                                <div className="conversation-wizard-edit-text">
                                    <TextInput onTextSubmit={this.onEditSubmit.bind(this)} text={this.state[this.state.isSetTextShowing]} exitKey="Escape" onExitKey={this.onEditExit.bind(this)} />
                                </div>
                            </div>
                        ) : ('')
                    }

                    {
                        (!this.state.isResourceSelectShowing && !this.state.isTypeSelectShowing && !this.state.isOrganisationSelectShowing) ? (
                            <Menu options={[
                                    {
                                        text: 'Zone Name: ',
                                        hint: this.state.name,
                                    },
                                    {
                                        text: 'Description: ',
                                        hint: this.state.description
                                    },
                                    {
                                        text: 'Organisation: ',
                                        hint: this.state.organisation?.name || 'Personal zone',
                                        className: this.state.organisation ? 'disabled' : '',
                                    },
                                    {
                                        text: 'Type: ',
                                        hint: this.state.type
                                    },
                                    {
                                        text: 'Allowed resources: ',
                                        hint: this.getAllowedResourcesHint()
                                    },
                                    {
                                        text: 'Location: ',
                                        hint: locationHint
                                    },
                                ]}
                                optionChosen={(option) => (this.chooseOption(option, event))}
                                menuContainer="organisation-container"
                            />
                        ) : ('')
                    }

                    {
                        this.state.isResourceSelectShowing ? (
                            <div className="top-ting">
                                <div className="my-inventory conversation-tree-wizard-container">
                                    <Menu options={
                                            RESOURCE_OPTIONS.map((option) => {
                                                if (this.state.allowedResources.find(allowed => allowed.serviceName === option.serviceName)) {
                                                    return {
                                                        ...option,
                                                        hint: ' Selected'
                                                    }
                                                }

                                                // Find if any children are selected
                                                let typeName = option.serviceName.split('-')[0] + 'Types';

                                                if (typeName === 'writingTypes') {
                                                    typeName = 'writingSurfaceTypes'
                                                }

                                                const isChildResourceTypeSelected = this.props[typeName].find((option) => {
                                                    if (this.state.allowedResourceTypes.find(resourceId => resourceId === option._id)) {
                                                        return true;
                                                    }
                                                });

                                                if (isChildResourceTypeSelected) {
                                                    return {
                                                        ...option,
                                                        hint: ' Filtered'
                                                    }
                                                }


                                                return option
                                            })
                                        }
                                        optionChosen={this.onResourceChosen.bind(this)}
                                        keyPressed={this.onResourcesKeyPressed.bind(this)}
                                        highlightedOption={this.onResourceServiceHighlighted.bind(this)}
                                        // navigation={this.onNavigation.bind(this)}
                                        menuContainer="conversation-tree-wizard-container"
                                        isDisabled={this.state.isServiceMenuDisabled}
                                    />
                                </div>
                                <div className="tile-inventory">
                                    <Menu options={
                                        this.getResourceTypeOptions()
                                    }
                                    optionChosen={this.onResourceTypeChosen.bind(this)}
                                    keyPressed={this.onResourcesKeyPressed.bind(this)}
                                    // navigation={this.onNavigation.bind(this)}
                                    menuContainer="conversation-tree-wizard-container"
                                    isDisabled={this.state.isTypeMenuDisabled}
                                    />
                                </div>
                            </div>
                        ) : null
                    }

                    {
                        this.state.isTypeSelectShowing ? (
                            <div className="conversation-tree-wizard-container">
                                <Menu options={[
                                        { text: 'Stockpile', hint: this.state.type === 'Stockpile' ? ' Selected' : '' },
                                        { text: 'Hoard', hint: this.state.type === 'Hoard' ? ' Selected' : '' },
                                        { text: 'Deposit', hint: this.state.type === 'Deposit' ? ' Selected' : '' },
                                    ]}
                                    optionChosen={this.onTypeChosen.bind(this)}
                                    keyPressed={this.onTypeKeyPressed.bind(this)}
                                    // navigation={this.onNavigation.bind(this)}
                                    menuContainer="conversation-tree-wizard-container"
                                />
                            </div>
                        ) : null
                    }

                    {
                        this.state.isOrganisationSelectShowing ? (
                            <div className="conversation-tree-wizard-container">
                                <Menu options={
                                        [
                                            {
                                                text: 'No Organisation (Personal zone)',
                                            },
                                            ...this.props.adminOrganisations.map(organisation => ({ ...organisation, text: organisation.name }))
                                        ]
                                        .map((organisation, index) => {
                                            if (!this.state.organisation && index === 0) {
                                                return {
                                                    ...organisation,
                                                    hint: ' Selected'
                                                }
                                            }

                                            if (this.state.organisation?._id === organisation?._id) {
                                                return {
                                                    ...organisation,
                                                    hint: ' Selected'
                                                }
                                            }

                                            return {
                                                ...organisation
                                            }
                                        })
                                    }
                                    optionChosen={this.onOrganisationChosen.bind(this)}
                                    keyPressed={this.onOrganisationKeyPressed.bind(this)}
                                    // navigation={this.onNavigation.bind(this)}
                                    menuContainer="conversation-tree-wizard-container"
                                />
                            </div>
                        ) : null
                    }
                </div>
                {
                    this.state.isResourceSelectShowing ? (
                        <div className="conversation-tree-actions-container">
                            <>
                                <p className={this.isEnabled('editName') ? "" : "hidden"}><span className="action">ENTER</span> - Toggle resource</p>
                                <p className={this.isEnabled('editName') ? "" : "hidden"}><span className="action">s</span> - Filter resources</p>
                            </>
                        </div>
                    ) : null
                }
                {this.state.isSearchShowing ? (
                                    <div className="search-bar">
                                        <p className="conversation-wizard-exit"><span className="action">ESC</span> to exit</p>
                                        <TextInput onTextSubmit={this.onSearchSubmit.bind(this)} onTextUpdate={this.onSearchUpdate.bind(this)} text={''} exitKey="Escape" onExitKey={this.onSearchExit.bind(this)} />
                                    </div>
                                ) : ('')
                }
                {
                    !this.state.isResourceSelectShowing && !this.state.isOrganisationSelectShowing ? (
                        <div className="conversation-tree-actions-container">
                            <>
                                <p className={this.isEnabled('deleteZone') ? "" : "hidden"}><span className="action">X</span> - <span className="error">Delete zone (after x type delete to confirm)</span></p>
                            </>
                        </div>
                    ) : null
                }
            </div>
        )
    }
}

const mapStateToProps = state => {
    const characters = selectCharacters(state);
    const character = selectCharacter(state);
    const zones = selectZones(state);
    const zone = selectOpenZone(state)
    const organisations = selectCharacterZoneOrganisations(state, character._id)
    const adminOrganisations = selectCharacterZoneAdminOrganisations(state, character._id)
    const areaSelect = selectAreaSelect(state)
    const panel = selectPanel(state)

    const materialTypes = selectMaterialTypes(state);
    const mineralTypes = selectMineralTypes(state);
    // const plantTypes = selectPlantTypes(state);
    const tileTypes = selectTileTypes(state);
    const toolTypes = selectToolTypes(state);
    const metalTypes = selectMetalTypes(state);
    const keyTypes = selectKeyTypes(state);
    // const machineTypes = selectMachineTypes(state);
    const furnitureTypes = selectFurnitureTypes(state);
    // const constructionTypes = selectConstructionTypes(state);
    const writingSurfaceTypes = selectWritingSurfaceTypes(state);
    const writingImplementTypes = selectWritingImplementTypes(state);
    const weaponTypes = selectWeaponTypes(state);
    const armourTypes = selectArmourTypes(state);
    const clothingTypes = selectClothingTypes(state);
    const jewelleryTypes = selectJewelleryTypes(state);
    const foodTypes = selectFoodTypes(state);
    // const lockTypes = selectLockTypes(state);
    // const animalTypes = selectAnimalTypes(state);
    // const boatTypes = selectBoatTypes(state);
    // const brainchipTypes = selectBrainchipTypes(state);
    // const tentTypes = selectTentTypes(state);
    const workshopTypes = selectWorkshopTypes(state);
    // const wagonTypes = selectWagonTypes(state);
    // const plantProducts = selectPlantProducts(state);
    // const constructionRecipes = selectConstructionRecipes(state);

    return {
        characters: characters.map(character => ({ ...character, text: character.name })),
        character,
        zone,
        adminOrganisations,
        organisations,
        areaSelect,
        panel,
        materialTypes,
        mineralTypes,
        // plantTypes,
        tileTypes,
        toolTypes,
        metalTypes,
        keyTypes,
        furnitureTypes,
        writingSurfaceTypes,
        writingImplementTypes,
        weaponTypes,
        armourTypes,
        clothingTypes,
        jewelleryTypes,
        foodTypes,
        workshopTypes,
    }
}

export default connect(
    mapStateToProps,
    { hideAllMenus, newOrganisation, showOrganisation, startAreaSelect, deleteZoneAsync, createZoneAsync, updateZone }
)(Zone);